import { render, staticRenderFns } from "./MyProfileDetailsNew.vue?vue&type=template&id=4f6d24a0&scoped=true&"
import script from "./MyProfileDetailsNew.vue?vue&type=script&lang=ts&"
export * from "./MyProfileDetailsNew.vue?vue&type=script&lang=ts&"
import style0 from "./MyProfileDetailsNew.vue?vue&type=style&index=0&id=4f6d24a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6d24a0",
  null
  
)

export default component.exports